import type { MouseEvent } from 'react'

// Move keyboard focus to the main landmark.
//
// A bare `href="#main-content"` relies on the browser focusing the fragment
// target itself. Chromium does not do it reliably here — a click works and a
// keyboard Enter does not, which is exactly backwards for a control that
// exists for keyboard users. Doing it explicitly works the same on both paths.
export function skipToMain(event: MouseEvent<HTMLAnchorElement>) {
  const main = document.getElementById('main-content')
  if (!main) return
  event.preventDefault()
  main.focus()
  history.replaceState(null, '', '#main-content')
}
